import "./WholeHomeInteriorRemodeling.module.css";
import Header from "@/reusable_sections/Header";
import Intro from "./sections/Intro";
import Remodeling from "./sections/Remodeling";
import Modernization from "./sections/Modernization";
import Gallery from "./sections/Gallery";
import Questions from "./sections/Questions";
import Action from "./sections/Action";
import EstimateRequestForm from "./sections/EstimateRequestForm";
import RenovationCtaBand from "./sections/RenovationCtaBand";
import Footer from "@/reusable_sections/Footer";
export default function WholeHomeInteriorRemodelingPage() {
  return <div>
      <Header />
      <Intro />
      <Remodeling />
      <RenovationCtaBand />
      <Modernization />
      <Gallery />
      <Questions />
      <EstimateRequestForm />
      <Action />
      <Footer />
    </div>;
}